import { ColorRank, DeckRadarSearchDto, DeckRadarStatusRequestDto, DeckSearchMode } from "../types/battle"
import { RANK_NAMES } from "../constants/guardians"

export function normalizeDeckSearchMode(value: unknown): DeckSearchMode {
  const raw = String(value ?? "").toUpperCase()
  return raw === "ANY" ? "ANY" : "RANK"
}

export function buildDeckRadarStatusRequest(
  deckSearchMode: DeckSearchMode,
  colorRank?: ColorRank
): DeckRadarStatusRequestDto {
  if (deckSearchMode === "ANY") {
    return { deckSearchMode: "ANY" }
  }
  return { deckSearchMode: "RANK", colorRank }
}

export function buildDeckRadarSearchDto(
  deckSearchMode: DeckSearchMode,
  cardIds: string[],
  colorRank?: ColorRank
): DeckRadarSearchDto {
  if (deckSearchMode === "ANY") {
    return { deckSearchMode: "ANY", cardIds }
  }
  return {
    deckSearchMode: "RANK",
    colorRank: colorRank ?? "WHITE",
    cardIds,
  }
}

export function buildDeckChallengeSendDto(
  targetUserId: number,
  deckSearchMode: DeckSearchMode,
  cardIds: string[],
  colorRank?: ColorRank
) {
  if (deckSearchMode === "ANY") {
    return { targetUserId, deckSearchMode: "ANY" as const, cardIds }
  }
  return {
    targetUserId,
    deckSearchMode: "RANK" as const,
    colorRank: colorRank ?? "WHITE",
    cardIds,
  }
}

export function formatDeckSearchModeLabel(
  deckSearchMode: DeckSearchMode,
  colorRank?: ColorRank
): string {
  if (deckSearchMode === "ANY") return "Любые 6 карт"
  if (colorRank) return `По рангу · ${RANK_NAMES[colorRank]}`
  return "По рангу"
}

export function canStartDeckBuilder(
  deckSearchMode: DeckSearchMode,
  options: {
    rankOptionsCount: number
    canBuildAnyDeck?: boolean
    totalCards?: number
    collectionCount: number
  }
): boolean {
  if (deckSearchMode === "ANY") {
    if (options.canBuildAnyDeck != null) return options.canBuildAnyDeck
    const total = options.totalCards ?? options.collectionCount
    return total >= 6
  }
  return options.rankOptionsCount > 0
}
